module.exports = __webpack_public_path__ + "static/media/camera.a5afbbbe.svg";